(function () {
	'use strict';
	angular.module('mx.SolutionBuilderAgent').component('mxSidePanelTabBody', {
		controller: function () {},
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-side-panel/mx-side-panel-tab-body.html',
		bindings: { view: '<' },
	});
})();
